import { DeviceSet } from "./DeviceSet";
import { Dictionary } from "../Utils/Dictionary";
import { HashSet } from "../Utils/HashSet";
import { List } from "../Utils/List";
import { DependentDeviceId } from "./DependentDeviceId";
import { Device } from "./Device";
import { DeviceKey } from "./Keys";

export class DependentDeviceTable {
    private _Parent: DeviceSet;
    private _Map: Dictionary<DependentDeviceId, List<Device>>;

    constructor(parent: DeviceSet) {
        this._Parent = parent;
        this._Map = new Dictionary<DependentDeviceId, List<Device>>();
    }

    public get DependentDeviceIds(): HashSet<DependentDeviceId> {
        return new HashSet<DependentDeviceId>(this._Map.Keys());
    }

    public get OverlappedDependentDeviceIds(): HashSet<DependentDeviceId> {
        var result = new HashSet<DependentDeviceId>();

        this._Map.ForEach((entry) => {
            var id: DependentDeviceId = entry.Key;
            var devices: List<Device> = entry.Value;
            if (devices.Count > 1)
                result.Add(id);
        }, this);

        return result;
    }

    public Clear(): void {
        this._Map.Clear();
    }

    public Add(device: Device): void {
        if (device.HasDependentDeviceId) {
            var id: DependentDeviceId = device.DependentDeviceId;
            var devices: List<Device> = null;
            if (this._Map.ContainsKey(id)) {
                devices = this._Map.Item(id);
            }
            else {
                devices = new List<Device>();
                this._Map.Add(id, devices);
            }
            devices.Add(device);
        }
    }

    public Remove(device: Device): void {
        if (device.HasDependentDeviceId) {
            var id: DependentDeviceId = device.DependentDeviceId;
            if (this._Map.ContainsKey(id)) {
                var devices: List<Device> = this._Map.Item(id);
                devices.Remove(device);
                if (devices.Count == 0) {
                    this._Map.Remove(id);
                }
            }
        }
    }

    public FindByControllerDevice(controller: Device): List<Device> {
        var deviceList: List<Device> = new List<Device>();

        this._Map.ForEach((entry) => {
            var id: DependentDeviceId = entry.Key;
            if (!id.HasControllerDevice && this._Parent != null) {
                id.ResolveControllerDevice(this._Parent);
            }
            if (id.HasControllerDevice) {
                if ((id.ControllerDevice == controller) ||
                    (controller.HasGUID && id.ControllerDevice.GUID == controller.GUID)) {
                    deviceList.UnionWith(entry.Value);
                }
            }
        }, this);

        return deviceList;
    }

    public FindByDependentDeviceId(id: DependentDeviceId): List<Device> {
        if (this._Map.ContainsKey(id))
            return this._Map.Item(id);
        else
            return new List<Device>();
    }

    public FindByControllerDeviceKey(controllerKey: DeviceKey): List<Device> {
        var deviceList: List<Device> = new List<Device>();

        this._Map.ForEach((entry) => {
            var id: DependentDeviceId = entry.Key;
            if (DeviceKey.IsMatch(id.ControllerKey, controllerKey)) {
                deviceList.UnionWith(entry.Value);
            }
        }, this);

        return deviceList;
    }

}
